<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import VSelect from "@/components/ui/VSelect.vue";
import countriesApi from "../api/resources/countriesApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getCountries() {
      countriesApi.index().then((response) => {
        this.options = response.data.map((country) => {
          return { text: country.name, value: country.id };
        });
      });
    },
  },

  created() {
    this.getCountries();
  },
};
</script>

<style></style>
